import React, { useCallback, useEffect, useState } from "react";
import { Spacer } from "components/base/Spacer";
import { Collapse } from "react-collapse";

import { useWindowWidth } from "hooks";
import { FilterSectionFlexboxGrid, StyledItemFitWidth, StyledItemAutoMargin } from "components/base/FitContainers";
import PaymentsSectionHeader from "components/Payments/PaymentsSectionHeader";
import { ButtonPrimary } from "components/base/BaseButton";
import PaymentsRequestTable from "../../Payments/PaymentsRequestSection/PaymentsRequestTable";
import ModalChangePaymentRequestStatus from "../../Payments/ModalChangePaymentRequestStatus";


export default ({
    // service,
    accountId,
    currencyName,
    paymentRequestItems,
    paymentRequestLoading,
    rejectPaymentRequest,
    approvePaymentRequest,
    getPaymentRequestList,
    openModalRequestPayment,
    openModalPaymentDetail,
    updateAccount
}) => {

    const windowWidth = useWindowWidth();
    const isMobile = windowWidth < 767;

    const [showTable, setShowTable] = useState(false);
    const [selectedRequest, setSelectedRequest] = useState(null);
    const [showModalCancelPaymentRequest, setShowModalCancelPaymentRequest] = useState(false);
    const [showModalApprovePaymentRequest, setShowModalApprovePaymentRequest] = useState(false);

    useEffect(() => {
        if (accountId) {
            getPaymentRequestList({
                target: { account_id: accountId }
            });
        }
    }, [accountId, getPaymentRequestList]);

    const handleCancelPaymentRequest = useCallback((value) => {
        setSelectedRequest(value);
        setShowModalCancelPaymentRequest(true);
    }, []);

    const handleCancelPayment = async () => {
        const data = {
            target: {
                payment_request_id: (selectedRequest || {})["id"]
            },
        };

        await rejectPaymentRequest(data).then((response) => {
            if (response?.payment_request) {
                getPaymentRequestList({
                    target: { account_id: accountId }
                });
                if (updateAccount) {
                    updateAccount(accountId);
                }
            }
        });
    };


    const handleApprovePaymentRequest = useCallback((value) => {
        setSelectedRequest(value);
        setShowModalApprovePaymentRequest(true);
    }, []);

    const toggleTable = useCallback(() => {
        setShowTable(prev => !prev);
    }, []);

    const handleApprovePayment = async () => {
        const data = {
            target: {
                payment_request_id: (selectedRequest || {})["id"]
            }
        };

        await approvePaymentRequest(data);

        getPaymentRequestList({
            target: { account_id: accountId }
        });
    };

    return (
        <>
            <PaymentsSectionHeader
                title="Payment request"
                show={showTable}
                callback={toggleTable}
            />

            <Collapse isOpened={showTable}>
                <div>
                    <Spacer />
                    <FilterSectionFlexboxGrid controlable={!isMobile}>
                        <StyledItemFitWidth isMobile={isMobile} controlable={!isMobile}></StyledItemFitWidth>

                        <StyledItemAutoMargin>
                            <ButtonPrimary onClick={openModalPaymentDetail}>
                                Manage payment details
                            </ButtonPrimary>

                            <ButtonPrimary onClick={openModalRequestPayment}>
                                Request payment
                            </ButtonPrimary>
                        </StyledItemAutoMargin>
                    </FilterSectionFlexboxGrid>

                    <PaymentsRequestTable
                        height={160}
                        data={paymentRequestItems}
                        loading={paymentRequestLoading}
                        {...{
                            handleCancelPaymentRequest,
                            handleApprovePaymentRequest,
                            currencyName,
                        }}
                    />
                </div>
            </Collapse>

            <ModalChangePaymentRequestStatus
                title="Approve payment request"
                show={showModalApprovePaymentRequest}
                onClose={() => {
                    setShowModalApprovePaymentRequest(false)
                }}
                onSuccess={handleApprovePayment}
            />

            <ModalChangePaymentRequestStatus
                title="Cancel payment request"
                show={showModalCancelPaymentRequest}
                onClose={() => {
                    setShowModalCancelPaymentRequest(false)
                }}
                onSuccess={handleCancelPayment}
            />
        </>
    );
};